import { render, staticRenderFns } from "./employeemangent.vue?vue&type=template&id=55b6ed49&scoped=true"
import script from "./employeemangent.vue?vue&type=script&lang=js"
export * from "./employeemangent.vue?vue&type=script&lang=js"
import style0 from "./employeemangent.vue?vue&type=style&index=0&id=55b6ed49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6ed49",
  null
  
)

component.options.__file = "employeemangent.vue"
export default component.exports